export const HR_TEAM_LOCATIONS = [
  "Bangalore",
  "Hyderabad",
  "Pune",
  "Chennai",
  "Jodhpur",
];

export const UNRESTRICTED_HR_TEAM_LOCATION = "Bangalore";

export const normalizeLocation = (location) =>
  typeof location === "string" ? location.trim().toLowerCase() : "";

export const getCanonicalLocation = (location) =>
  HR_TEAM_LOCATIONS.find(
    (allowedLocation) =>
      normalizeLocation(allowedLocation) === normalizeLocation(location)
  ) || "";

export const getHrTeamLocation = (user) =>
  user && (user.hrTeamLocation || user.workLocation || "");

export const isUnrestrictedHr = (user) =>
  normalizeLocation(getHrTeamLocation(user)) ===
  normalizeLocation(UNRESTRICTED_HR_TEAM_LOCATION);
